import React, { useEffect } from "react";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $, { data } from "jquery";

class ActiveerMaatregelModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      begin: "",
      end: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleSubmit = () => {
    $("#cover-spin").show(0);

    var element = $("input[name=wijzig-status]:checked");
    var status = element[0].defaultValue;
    var uitvoerderId = $("input[name=uitvoerder]:checked").attr("id");

    var model = {
      status: status,
      uitvoerder: uitvoerderId,
      periode: [
        this.state.begin + "T00:00:00.000Z",
        this.state.end + "T00:00:00.000Z",
      ],
    };

    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    GC.StartActivity(
      model,
      selectedIds,
      "17a25835-e4f8-4189-bcaa-30b7194c7c2b",
      this.plaatsInUitvoering,
      window.$mm_management_units_token
    );
  };
  plaatsInUitvoering = () => {
    GC.sleep(500).then(() => {
      $("#plaats_in_detailplanning").modal("hide");
      window.$mm_work_plans_refresh();
      /*omnimap
        .FillTableAction(
          window.$mm_work_plans_lastUsedTableFilter,
          1,
          window.$mm_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  };

  componentDidMount() {
    var that = this;
    $("#plaats_in_detailplanning").on("show.bs.modal", async function (event) {
      var selectedIds = [];

      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      let result = await omnimap.GetActivityDefinitionAction(
        selectedIds[0],
        "3a98846b-67c1-4192-9edc-b980f10898b8",
        window.$mm_management_units_token
      );

      CallBackFunctions.WijzigStatusCallback(result, "status-grp");

      let model = {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: ["74eb43ef-68bf-40b9-af29-320951366dcb"],
      };
      let uitvoerderResult = await omnimap
        .FillTableAction(model, 1, window.$mm_management_units_token)
        .catch((err) => {
          alert(err);
        });
      CallBackFunctions.UitvoerderCallback(uitvoerderResult, 1);

      let rowOfDetail = await omnimap.GetRowOfDetailAction(
        selectedIds[0],
        window.$mm_management_units_token
      );

      await that.setState({
        begin: GC.FormatDateReverse(
          rowOfDetail.data.content.planning.detailplanning
            ? rowOfDetail.data.content.planning.detailplanning[0]
            : rowOfDetail.data.content.planning.globaleplanning[0],
          "date"
        ),
        end: GC.FormatDateReverse(
          rowOfDetail.data.content.planning.detailplanning
            ? rowOfDetail.data.content.planning.detailplanning[1]
            : rowOfDetail.data.content.planning.globaleplanning[1],
          "date"
        ),
      });
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="plaats_in_detailplanning"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Plaats in Detailplanning</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div class="beheeractiviteit-zoeken-content">
                <input
                  id="beheeractiviteit-zoeken-input"
                  type="search"
                  className="modal-search"
                  placeholder="Zoeken"
                  autocomplete="off"
                />
              </div>

              <div className="modal-scroll">
                <div id="status-grp" className="radio-grp" />
              </div>

              <div class="btn-plannig-context">
                <h2>Periode:</h2>

                <p>Begin</p>
                <input
                  id="beheereenheid_begin"
                  type="date"
                  className="form-control"
                  placeholder="Horizon Begin"
                  name="begin"
                  value={this.state.begin}
                  onChange={this.handleInputChange}
                />
                <p>Einde</p>
                <input
                  id="beheereenheid_end"
                  type="date"
                  className="form-control"
                  placeholder="Horizon Einde"
                  name="end"
                  value={this.state.end}
                  onChange={this.handleInputChange}
                />
                <br />
                <h1>Uitvoerder:</h1>
                <p>Geselecteerd: Niets geselecteerd </p>
                <input
                  id="planningsperiode"
                  type="search"
                  className="modal-search"
                  placeholder="Zoeken"
                />
                <div className="modal-scroll">
                  <div id="uitvoerder-grp" className="radio-grp" />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ActiveerMaatregelModal;
